// TODO: https://docs.adyen.com/point-of-sale/design-your-integration/choose-your-architecture/local/#handle-network-issues
// https://docs.adyen.com/point-of-sale/design-your-integration/terminal-api/#request-message-header
// https://docs.adyen.com/point-of-sale/design-your-integration/choose-your-architecture/local
// https://docs.adyen.com/point-of-sale/basic-tapi-integration/verify-transaction-status
import dayjs from 'dayjs'
import type { IPayTxPayload, IPayTxResp, IXTerminal } from '@/react/Terminal/IXTerminal.ts'
import { rnHost } from '@/shared/webview/rnwebview.ts'
import uuid from 'time-uuid'

export enum ResultType {
  Failure = "Failure",
  Partial = "Partial",
  Success = "Success",
}

export type AdyenLocalTerminalMetadata = {
  host: string
  port: string
  poiID: string
  saleID: string,
  keyIdentifier: string,
  passphrase: string
  isSandbox: boolean | undefined
}

export default class AdyenLocalTerminal implements IXTerminal {
  baseUrl: string
  // The unique ID of the terminal that you send this request to.
  // Format: [device model]-[serial number]. For example, P400‑123456789.
  PoiID: string
  SaleID: string
  keyIdentifier: string
  passphrase: string

  constructor(props: AdyenLocalTerminalMetadata) {
    console.log('AdyenLocalTerminal::ctor', props)
    this.baseUrl = `https://${props.host}:${props.port}`
    this.PoiID = props.poiID
    this.SaleID = props.saleID
    this.keyIdentifier = props.keyIdentifier
    this.passphrase = props.passphrase
    rnHost.initAdyen(!!props.isSandbox, props.host, props.poiID, props.saleID, props.keyIdentifier, props.passphrase, 120000)
  }

  async payTx(payload: IPayTxPayload, onProgress?: Function | undefined): Promise<{ error: string, response?: any } | IPayTxResp> {
    // https://docs.adyen.com/point-of-sale/design-your-integration/terminal-api/#request-message-header
    const ssid = `adyen-payTx-${uuid()}`
    try {
      const totalAmount = payload.amount + payload.tip
      const terminalAPIResponse = await rnHost.sendAdyenPaymentTx(totalAmount, 'EUR')
      // TODO: log o2
      console.log(ssid, JSON.stringify(terminalAPIResponse));
      if (terminalAPIResponse) {
        const {PaymentResponse} = terminalAPIResponse?.SaleToPOIResponse
        const {
          POIData: {POITransactionID: {TransactionID}},
          PaymentResult: {AmountsResp},
          Response: {Result},
        } = PaymentResponse;
        console.log(ssid, 'step 1')
        switch (Result) {
          case ResultType.Success:
            const {AuthorizedAmount} = AmountsResp;
            console.log(ssid, 'success')
            if (Math.round(totalAmount * 100) === Math.round(AuthorizedAmount * 100)) {
              console.log(ssid, 'success 1')
              return {
                response: {
                  type: 'adyen',
                  payment: {
                    amount: Math.round(payload.amount * 100),
                    tipAmount: Math.round(payload.tip * 100),
                    taxAmount: 0,
                    createdTime: Date.now(),
                    externalPaymentId: TransactionID,
                    rawResult: terminalAPIResponse,
                    result: 'SUCCESS',
                  }
                }
              }
            } else {
              console.log(ssid, 'success 2')
              // TODO: realtime alert
              return {
                response: {
                  type: 'adyen',
                  payment: {
                    amount: Math.round(AuthorizedAmount * 100),
                    tipAmount: 0,
                    taxAmount: 0,
                    createdTime: Date.now(),
                    externalPaymentId: TransactionID,
                    rawResult: terminalAPIResponse,
                    result: 'SUCCESS',
                  }
                }
              }
            }
          case ResultType.Partial:
            console.log(ssid, 'Partial 1')
            // TODO: Realtime alert
            return {
              error: `Payment failure - Partial: Payment terminal responded with Partial`,
              response: terminalAPIResponse
            }
          case ResultType.Failure:
            console.log(ssid, 'failure 1')
            return {
              error: `Payment failure - refusalReason: ${'Payment terminal responded with: ' + PaymentResponse.Response.ErrorCondition}`,
              response: terminalAPIResponse
            }
          default:
            console.log(ssid, 'default')
            return {
              error: `Could not reach payment terminal with POI ID ${this.PoiID}`,
              response: terminalAPIResponse
            }
        }
      } else {
        console.log(ssid, 'Empty payment response')
        return {
          error: 'Empty payment response',
        }
      }
    } catch (e: any) {
      // TODO: send log o2
      console.log(ssid, 'error', e.message)
      return { error: e.message }
    }
  }

  async refundTx(payload: any, onProgress?: Function | undefined): Promise<any> {
    // Use a unique transaction for every transaction you perform
    const ssid = `adyen-refundTx-${uuid()}`
    try {
      console.log(ssid, JSON.stringify(payload));
      const terminalAPIResponse = await rnHost.sendAdyenReversalTx(payload.poiTransactionId, payload.saleTransactionId, 'MerchantCancel')
      console.log(ssid, JSON.stringify(terminalAPIResponse))
      if (terminalAPIResponse) {
        const reversalResponse = terminalAPIResponse?.SaleToPOIResponse?.ReversalResponse
        switch (reversalResponse?.Response?.Result) {
          case ResultType.Success:
            console.log(ssid, 'success')
            return {
              response: {
                ssid,
                rawResult: terminalAPIResponse
              }
            }
          case ResultType.Partial:
            console.log(ssid, 'Partial')
            return {
              error: `Payment failure - refusalReason: ${'Partial refund not implemented: ' + JSON.stringify(reversalResponse.Response)}`,
              response: {
                ssid,
                rawResult: terminalAPIResponse
              }
            }
          case ResultType.Failure:
            console.log(ssid, `Payment failure - refusalReason: ${'Payment terminal responded with: ' + JSON.stringify(reversalResponse.Response)}`)
            return {
              error: `Payment failure - refusalReason: ${'Payment terminal responded with: ' + JSON.stringify(reversalResponse.Response)}`,
              response: {
                ssid,
                rawResult: terminalAPIResponse
              }
            }
          default:
            console.log(ssid, `Could not reach payment terminal with POI ID ${this.PoiID}`)
            return {
              error: `Could not reach payment terminal with POI ID ${this.PoiID}`,
              response: {
                ssid,
                rawResult: terminalAPIResponse
              }
            }
        }
      } else {
        console.log(ssid, 'Empty payment response')
        return {
          error: 'Empty payment response',
          response: {
            ssid,
            rawResult: terminalAPIResponse
          }
        }
      }
    } catch (e: any) {
      console.log(ssid, 'error', e.message)
      return { error: e.message }
    }
  }

  async voidTx(payload: any, onProgress?: Function | undefined): Promise<any> {
    throw new Error('Method not implemented.')
  }

  async cancel(payload: any, onProgress?: Function | undefined): Promise<any> {
    // Step 5: Make the request
    try {
      const terminalAPIResponse = await rnHost.sendAdyenAbortTx(payload.serviceId, 'Payment', 'MerchantAbort');
      if (terminalAPIResponse) {
        const paymentResponse = terminalAPIResponse?.SaleToPOIResponse?.PaymentResponse
        const POIData = paymentResponse?.POIData
        const saleData = paymentResponse?.SaleData
        switch (paymentResponse?.Response?.Result) {
          case ResultType.Success:
            return {
              response: {
                type: 'adyen',
                payment: {
                  amount: 0,
                  tipAmount: 0,
                  taxAmount: 0,
                  createdTime: dayjs().unix(),
                  externalPaymentId: '',
                  rawResult: paymentResponse,
                },
              },
            }
          case ResultType.Failure:
            return {
              error: `Payment failure - refusalReason: ${'Payment terminal responded with: ' + paymentResponse.Response.ErrorCondition}`,
            }
          case ResultType.Partial:
            return {
              error: `Payment failure - refusalReason: ${'Partial refund not implemented: ' + paymentResponse.Response.ErrorCondition}`,
            }
          default:
            return {
              error: `Could not reach payment terminal with POI ID ${this.PoiID}`,
            }
        }
      } else {
        return {
          error: 'Empty payment response',
        }
      }
    } catch (e: any) {
      return { error: e.message }
    }
  }

  test(onProgress?: Function | undefined): Promise<any> {
    throw new Error('Method not implemented.')
  }

  isOnline(): Promise<boolean> {
    throw new Error('Method not implemented.')
  }

  eod(): void {
    throw new Error('Method not implemented.')
  }
}
